import { salesLabX } from "./brandValues/salesLabX";
import { threeDegrees } from "./brandValues/threeDegrees";
import { alen } from "./brandValues/alen";
import { appian } from "./brandValues/appian";
import { boost } from "./brandValues/boost";
import { brohnHomes } from "./brandValues/brohnHomes";
import { brookfieldProperties } from "./brandValues/brookfieldProperties";
import { canon } from "./brandValues/canon";
import { celliant } from "./brandValues/celliant";
import { cfc } from "./brandValues/cfc";
import { dechra } from "./brandValues/dechra";
import { defenseStorm } from "./brandValues/defenseStorm";
import { flightSafety } from "./brandValues/flightSafety";
import { guardantHealth } from "./brandValues/guardantHealth";
import { idf } from "./brandValues/idf";
import { jessup } from "./brandValues/jessup";
import { lares } from "./brandValues/lares";
import { ledvance } from "./brandValues/ledvance";
import { mgs } from "./brandValues/mgs";
import { mit } from "./brandValues/mit";
import { myonex } from "./brandValues/myonex";
import { rapidRecon } from "./brandValues/rapidRecon";
import { scElectric } from "./brandValues/scElectric";
import { sciton } from "./brandValues/sciton";
import { swh } from "./brandValues/swh";
import { studentreasures } from "./brandValues/stu";
import { volpara } from "./brandValues/volpara";
  
export const brandSelect = [
  { label: 'SalesLabX', value: 'SalesLabX' },
  { label: '3Degrees', value: 'ThreeDegrees' },
  { label: 'Alen', value: 'Alen' },
  { label: 'Appian', value: 'Appian' },
  { label: 'Boost', value: 'Boost' },
  { label: 'Brohn Homes', value: 'BrohnHomes' },
  { label: 'Brookfield Properties', value: 'BrookfieldProperties' },
  { label: 'Canon', value: 'Canon' },
  { label: 'Celliant', value: 'Celliant' },
  { label: 'CFC', value: 'CFC' },
  { label: 'Dechra', value: 'Dechra' },
  { label: 'DefenseStorm', value: 'DefenseStorm' },
  { label: 'FlightSafety', value: 'FlightSafety' },
  { label: 'GuardantHealth', value: 'GuardantHealth' },
  { label: 'IDF', value: 'IDF' },
  { label: 'Jessup', value: 'Jessup' },
  { label: 'Lares', value: 'Lares' },
  { label: 'Ledvance', value: 'Ledvance' },
  { label: 'MGS', value: 'MGS' },
  { label: 'MIT', value: 'MIT' },
  { label: 'Myonex', value: 'Myonex' },
  { label: 'RapidRecon', value: 'RapidRecon' },
  { label: 'S&CElectric', value: 'SCElectric' },
  { label: 'Sciton', value: 'Sciton' },
  { label: 'SWH', value: 'SWH' },
  { label: 'STU', value: 'STU' },
  { label: 'Volpara', value: 'Volpara' },
   
];

export const brandValues = {
  SalesLabX: salesLabX,
  ThreeDegrees: threeDegrees,
  Alen: alen,
  Appian: appian,
  Boost: boost,
  BrohnHomes: brohnHomes,
  BrookfieldProperties: brookfieldProperties,
  Canon: canon,
  Celliant: celliant,
  CFC: cfc,
  Dechra: dechra,
  DefenseStorm: defenseStorm,
  FlightSafety: flightSafety,
  GuardantHealth: guardantHealth,
  IDF: idf,
  Jessup: jessup,
  Lares: lares,
  Ledvance: ledvance,
  MGS: mgs,
  MIT: mit,
  Myonex: myonex,
  RapidRecon: rapidRecon,
  SCElectric: scElectric,
  Sciton: sciton,
  SWH: swh,
  STU: studentreasures,
  Volpara: volpara,

};